import { render, staticRenderFns } from "./weixinPupop.vue?vue&type=template&id=fafdf8d2&scoped=true&"
import script from "./weixinPupop.vue?vue&type=script&lang=js&"
export * from "./weixinPupop.vue?vue&type=script&lang=js&"
import style0 from "./weixinPupop.vue?vue&type=style&index=0&id=fafdf8d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafdf8d2",
  null
  
)

export default component.exports